export default __webpack_public_path__ + "static/media/promotion_small.d2b26224.svg";